import { RateSchema } from "@redotech/redo-model/outbound-labels/outbound-labels";
import * as z from "zod";

export const getShipmentRateDetails = {
  name: "getShipmentRateDetails" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({
    rateDetails: z.array(RateSchema),
    ghostAccountIds: z.array(z.string()).nullish(),
  }),
};
